import React from "react";
import {
  ApplicationStatus,
  ApplicationStatusGroups,
  TagStatus,
} from "../types";
import StatusTag from "./StatusTag";

const ApplicationStatusTag = (props: ApplicationStatusTagProps) => {
  const { status } = props;
  const label = status.replace("_", " ");

  return <StatusTag status={convertToGenericStatus(status)}>{label}</StatusTag>;
};

type ApplicationStatusTagProps = {
  status: ApplicationStatus;
};

const convertToGenericStatus = (status: ApplicationStatus): TagStatus => {
  const successStates = [ApplicationStatus.ACCEPTED_JOB];

  if (successStates.includes(status)) {
    return "success";
  }

  if (ApplicationStatusGroups.feedback.includes(status)) {
    return "warning";
  }

  if (ApplicationStatusGroups.interviewing.includes(status)) {
    return "info";
  }

  if (ApplicationStatusGroups.rejected.includes(status)) {
    return "default";
  }

  return "info";
};

export default ApplicationStatusTag;
